import React from "react";
import Navbar from "./components/Navbar";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./components/pages/Home";
import Portfolio from "./components/pages/Portfolio";
import About from "./components/pages/About";
import Services from "./components/pages/Services";
import Contact from "./components/pages/Contact";
import Privacy from "./components/pages/Privacy-policy";
import ProjectPage from "./components/ProjectPage";
import FeaturedCaseStudies from "./components/FeaturedCaseStudies";
import CaseStudyPage from "./components/pages/CaseStudyPage";
import ScrollToTop from "./components/ScrollToTop"; // ✅ import


function App() {
  return (
    <>
      <Router>
        <ScrollToTop/>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/portfolio/:slug" element={<ProjectPage />} />{" "}
          {/* ← NEW */}
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route
            path="/case-studies"
            element={<FeaturedCaseStudies max={4} />}
          />
          <Route path="/case-studies/:slug" element={<CaseStudyPage />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
